// Esta marca não substitui situacao/pago nem decide se a conta pode receber baixa.
export function estadoPagamentoLegado(info) {
    if (!info || !info.previsao_parcela_id) return null;
    const paga = info.paga === true;
    const baixada = info.baixa_realizada === true;
    return {
        paga,
        baixada,
        editavel: info.pode_alterar === true && !baixada,
        titulo: paga ? 'Paga no processo antigo' : 'Não paga no processo antigo',
        // D-0107 (Rafael 28/10): o selo "Paga no processo antigo" já explica; sem o texto de orientação embaixo.
        orientacao: paga && baixada ? 'Baixa financeira registrada.' : '',
    };
}

// Atualiza só o campo confirmado pela API, preservando rascunhos de dados bancários/observação.
export function atualizarLegadoNasParcelas(parcelas, info) {
    return (parcelas || []).map(p => p.pagamento_legado
        && String(p.pagamento_legado.previsao_parcela_id) === String(info.previsao_parcela_id)
        ? { ...p, pagamento_legado: info } : p);
}

export function atualizarLegadoNoPlano(plano, info) {
    const novo = { ...plano };
    ['parcelas', 'parcelas_aprovadas', 'parcelas_efetivo'].forEach(campo => {
        if (Array.isArray(plano[campo])) novo[campo] = atualizarLegadoNasParcelas(plano[campo], info);
    });
    if (Array.isArray(plano.planos_vinculados)) {
        novo.planos_vinculados = plano.planos_vinculados.map(p => atualizarLegadoNoPlano(p, info));
    }
    return novo;
}

export function sincronizarLegadoNasParcelas(parcelas, fontes) {
    const porPrevisao = new Map((fontes || []).filter(p => p.pagamento_legado)
        .map(p => [String(p.pagamento_legado.previsao_parcela_id), p.pagamento_legado]));
    return (parcelas || []).map(p => {
        const id = p.previsao_parcela_id || p.pagamento_legado?.previsao_parcela_id;
        return porPrevisao.has(String(id)) ? { ...p, pagamento_legado: porPrevisao.get(String(id)) } : p;
    });
}
